import { arrayOf } from 'prop-types';
import React from 'react';
import Countdown from 'react-countdown';
import { GoTools } from 'react-icons/go';
import Moment from 'react-moment';
import { Alert } from 'reactstrap';

import { announcementShape } from '../../prop-types';
import { COLORS } from '../../utils/constants';
import { OUTAGE_TIME_FORMAT } from './constants';
import getUpcomingAnnouncement from './get-upcoming-announcements';
import OutageScreenSaver from './OutageScreenSaver';

function OutageReminder({ announcements }) {
  const announcement = getUpcomingAnnouncement(announcements);
  if (announcement.length === 0) {
    return null;
  }
  const currentAnnouncement = { ...announcement[0] };
  const { end, start } = currentAnnouncement;
  return (
    <Countdown
      date={end}
      renderer={({ completed: ended }) => {
        if (ended) {
          return null;
        }
        return (
          <Countdown
            date={start}
            renderer={({ completed: started }) => {
              if (started) {
                return <OutageScreenSaver end={end} />;
              }
              return (
                <>
                  {/* This div ensures that there is space at the bottom of the screen where the fixed Alert is rendered */}
                  <div className="p-4" />
                  <Alert
                    color={COLORS.WARNING}
                    className="c-flash-message-bottom m-0 d-flex align-items-center w-100"
                  >
                    <GoTools className="mr-4 h6 mb-0" />{' '}
                    <div data-qa-name="outage-reminder-message">
                      Sales Cockpit will be down for maintenance/upgrades
                      shortly from{' '}
                      <span className="font-weight-bold">
                        <Moment format="hh.mma">{start}</Moment>
                      </span>{' '}
                      to{' '}
                      <span className="font-weight-bold">
                        <Moment format={OUTAGE_TIME_FORMAT}>{end}</Moment>
                      </span>
                      . Please make sure to save your work in advance.
                    </div>
                  </Alert>
                </>
              );
            }}
          />
        );
      }}
    />
  );
}

OutageReminder.propTypes = {
  announcements: arrayOf(announcementShape.isRequired).isRequired,
};

export default OutageReminder;
